import React from 'react';
import { Funnel } from '@ant-design/plots';

export const FunnelChart = () => {
  const data = [
    { action: 'Aguardando atendimento', pv: 50000 },
    { action: 'Agendado Visita', pv: 35000 },
    { action: 'Em negociação', pv: 25000 },
    { action: 'Venda completa', pv: 10000 },
  ];

  const config = {
    data,
    xField: 'action',
    yField: 'pv',
    shapeField: 'pyramid',
    label: {
      formatter: (d) => `${d.pv}`,
      position: 'middle',
      style: {
        fontSize: 16,
        fill: '#fff',
      },
    },
    conversionTag: {
      formatter: (d, data) => {
        const index = data.findIndex(item => item.action === d.action);
        const prevValue = data[index - 1].pv;
        const percentage = (d.pv / prevValue) * 100;
        return `Conversão: ${percentage.toFixed(2)}%`;
      },
    },
    
  };

  return <Funnel {...config} />;
};
